// extracted by mini-css-extract-plugin
module.exports = {"descriptionGroup":"DescriptionGroup_descriptionGroup__PIT9t","description":"DescriptionGroup_description__UcIV9"};